import React from 'react';
import Tabs from '../Tabs/Tabs';
import ReportPresenterChartTitleSection from './Shared/ReportPresenterChartTitleSection';
import LineChartWrapper from './LineChart/LineChartWrapper';
import AreaChartWrapper from './AreaChart/AreaChartWrapper';
import ReportPresenterTable from './ReportPresenterTable/ReportPresenterTable';
import ReportPresenterDetails from './ReportPresenterDetails/ReportPresenterDetails';
import VerticalBarChartWrapper from './BarChart/VerticalBarChartWrapper';
import DualAxisLineChartWrapper from './LineChart/DualAxisLineChartWrapper';
import DateHelper from '../DateHelper/DateHelper';
const _cloneDeep = require('lodash/cloneDeep');

export default class ChartPresenter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 'report',
      tableData: [],
      viewOptionsSideBar: false,
      displayReportDetails: this.setDetails(),
      data: [],
      toolTipDetails: null,
      includeYOY: false,
      hiddenDetails: [],
    };
    this.onChange = this.onChange.bind(this);
    this.onClickSideBarSubmit = this.onClickSideBarSubmit.bind(this);
    this.onClickToolTip = this.onClickToolTip.bind(this);
    this.recDimensions = this.recDimensions.bind(this);
    this.onExportCSV = this.onExportCSV.bind(this)
  };

  setDetails(){
    let reportDetails = _cloneDeep(this.props.report_details);
    reportDetails.start_date ? reportDetails.start_date = DateHelper.parseDateFromBackend(reportDetails.start_date) : null;
    reportDetails.end_date ? reportDetails.end_date = DateHelper.parseDateFromBackend(reportDetails.end_date) : null;
    return reportDetails
  };

  componentDidMount() {
    this.setData();
  };

  render() {
    return (
      <div className="chart-presenter">
        <Tabs tabs={this.tabs()} />
        <div className="panel panel-form">
          <div className="tab-content">
            <div>
              <ReportPresenterChartTitleSection
                report_details={this.props.report_details}
                date_format={this.props.date_format}
                onChange={this.onChange}
                onClickSideBarSubmit={this.onClickSideBarSubmit}
                columnId={this.props.columnId}
                includeYOY={this.state.includeYOY}
              />
              {
                this.props.report_details.chart_type.name === 'line_chart' && this.state.activeTab === 'report' && this.state.data && this.state.data.length
                  ?
                  <LineChartWrapper
                    report_details={this.props.report_details}
                    // originalReportDetail={this.props.report_details}
                    new_record={this.props.new_record}
                    date_format={this.props.date_format}
                    time_format={this.props.time_format}
                    data={this.state.data}
                    dimensions={this.recDimensions}
                    onChange={this.onChange}
                    toolTipDetails={this.state.toolTipDetails}
                    onClickToolTip={this.onClickToolTip}
                    includeYOY={this.state.includeYOY}
                    columnId={this.props.columnId}
                    onToggleDataSource={this.onToggleDataSource}
                    hiddenDetails={this.state.hiddenDetails}
                  />
                  :
                  null
              }
              {
                this.props.report_details.chart_type.name === 'dual_axis_line_chart' && this.state.activeTab === 'report' && this.state.data && this.state.data.length
                  ?
                  <DualAxisLineChartWrapper
                    report_details={this.props.report_details}
                    new_record={this.props.new_record}
                    date_format={this.props.date_format}
                    time_format={this.props.time_format}
                    data={this.state.data}
                    dimensions={this.recDimensions}
                    onChange={this.onChange}
                    toolTipDetails={this.state.toolTipDetails}
                    onClickToolTip={this.onClickToolTip}
                    includeYOY={this.state.includeYOY}
                    columnId={this.props.columnId}
                    onToggleDataSource={this.onToggleDataSource}
                    hiddenDetails={this.state.hiddenDetails}
                  />
                  :
                  null
              }
              {
                this.props.report_details.chart_type.name === 'vertical_bar_chart' && this.state.activeTab === 'report' && this.state.data && this.state.data.length
                  ?
                  <VerticalBarChartWrapper
                    report_details={this.state.displayReportDetails}
                    new_record={this.props.new_record}
                    date_format={this.props.date_format}
                    time_format={this.props.time_format}
                    data={this.state.data}
                    dimensions={this.recDimensions}
                    onChange={this.onChange}
                    toolTipDetails={this.state.toolTipDetails}
                    onClickToolTip={this.onClickToolTip}
                    columnId={this.props.columnId}
                  />
                  :
                  null
              }
              {/* {
                this.props.report_details.chart_type.name === 'stacked_bar_chart' && this.state.activeTab === 'report' && this.state.data && this.state.data.length
                  ?
                  <StackedBarChartWrapper
                    report_details={this.state.displayReportDetails}
                    new_record={this.props.new_record}
                    date_format={this.props.date_format}
                    time_format={this.props.time_format}
                    data={this.state.data}
                    dimensions={this.recDimensions}
                    onChange={this.onChange}
                    toolTipDetails={this.state.toolTipDetails}
                    onClickToolTip={this.onClickToolTip}
                    columnId={this.props.columnId}
                  />
                  :
                  null
              } */}
              {/* {
                this.props.report_details.chart_type.name === 'horizontal_bar_chart' && this.state.activeTab === 'report' && this.state.data && this.state.data.length
                  ?
                  <HorizontalBarChartWrapper
                    report_details={this.state.displayReportDetails}
                    new_record={this.props.new_record}
                    date_format={this.props.date_format}
                    time_format={this.props.time_format}
                    data={this.state.data}
                    dimensions={this.recDimensions}
                    onChange={this.onChange}
                    toolTipDetails={this.state.toolTipDetails}
                    onClickToolTip={this.onClickToolTip}
                    columnId={this.props.columnId}
                  />
                  :
                  null
              } */}
              {
                this.props.report_details.chart_type.name === 'area_chart' && this.state.activeTab === 'report' && this.state.data && this.state.data.length
                  ?
                  <AreaChartWrapper
                    report_details={this.props.report_details}
                    new_record={this.props.new_record}
                    date_format={this.props.date_format}
                    time_format={this.props.time_format}
                    data={this.state.data}
                    dimensions={this.recDimensions}
                    onChange={this.onChange}
                    toolTipDetails={this.state.toolTipDetails}
                    onClickToolTip={this.onClickToolTip}
                    columnId={this.props.columnId}
                    hiddenDetails={this.state.hiddenDetails}
                  />
                  :
                  null
              }
              {
                this.state.activeTab === 'table' && this.state.data && this.state.data.length
                  ?
                  <ReportPresenterTable
                    report_details={this.state.displayReportDetails}
                    new_record={this.props.new_record}
                    date_format={this.props.date_format}
                    time_format={this.props.time_format}
                    tableData={this.state.data}
                    viewOptionsSideBar={this.state.viewOptionsSideBar}
                    onExportCSV={this.onExportCSV}
                  />
                  :
                  null
              }
            </div>
            {
              this.state.activeTab === 'details'
                ?
                <ReportPresenterDetails {...this.props} />
                :
                null
            }
          </div>
        </div>
      </div>
    );
  };

  tabs() {
    if (this.props.callSource !== 'ChartWidget'){
      return (
        [
          {
            tabName: I18n.t('report'),
            targetName: 'report',
            classes: this.state.activeTab === 'report' ? 'active' : null,
            changeHandler: this.onChangeTab,
          },
          {
            tabName: I18n.t('table'),
            targetName: 'table',
            classes: this.state.activeTab === 'table' ? 'active' : null,
            changeHandler: this.onChangeTab,
          },
          {
            tabName: I18n.t('details'),
            targetName: 'details',
            classes: this.state.activeTab === 'details' ? 'active' : null,
            changeHandler: this.onChangeTab,
          },
        ]
      );
    } else {
      return(
        [

        ]
      );
    };

  };

  onToggleDataSource = (dataColumnName)=>{
    if(this.state.hiddenDetails.find(hiddenDataColumnName => hiddenDataColumnName == dataColumnName)){
      var hiddenDetails = this.state.hiddenDetails.filter(hiddenDataColumnName => hiddenDataColumnName !== dataColumnName);
    } else {
      var hiddenDetails = [...this.state.hiddenDetails, dataColumnName];
    };

    this.setState({
      hiddenDetails: hiddenDetails
    });
  };

  onChangeTab = (name)=>{ this.setState({activeTab: name}); };

  onChange(value, key, reportDetail = false) {
    if (reportDetail) {
      var updatedReportDetails = _cloneDeep(this.state.displayReportDetails);
      updatedReportDetails[key] = value;

      this.setState({
        displayReportDetails: updatedReportDetails
      });
    } else {
      this.setState({
        [key]: value
      });
    };
  };

  onClickSideBarSubmit(reportDetails) {
    this.setData(reportDetails);
  };

  recDimensions() {
    var dimensions = {
      width: window.innerWidth * .8,
      height: 500,
      margin: {
        top: 30,
        right: this.props.report_details.chart_type.name === 'dual_axis_line_chart' ? 70 : 30,
        bottom: 110,
        left: 70
      }
    };
    dimensions.boundedWidth = dimensions.width - dimensions.margin.left - dimensions.margin.right
    dimensions.boundedHeight = dimensions.height - dimensions.margin.top - dimensions.margin.bottom
    return dimensions
  };

  onExportCSV(){
    this.setData( this.props.report_details, true )
  }

  setData(report_details = this.props.report_details, exportCSV = false) {
    typeof report_details.start_date == 'string' ? report_details.start_date = DateHelper.parseDateFromBackend(report_details.start_date) : null;
    typeof report_details.end_date == 'string' ? report_details.end_date = DateHelper.parseDateFromBackend(report_details.end_date) : null;
    // report_details.data_details = this.props.report_details.data_details.slice()
    var dataSources = this.uniqueDataSources(report_details);

    var dataPromises = this.getData(report_details, dataSources, exportCSV);
    this.resolveAggregateAndSetData(report_details, dataPromises)
  };

  uniqueDataSources(report_details) {
    return Array.from(new Set(this.props.report_details.data_details.map(detail => detail.data_source.id))).map(sourceId => report_details.data_details.find(detail => detail.data_source.id === sourceId).data_source);
  };

  getData(report_details, dataSources, exportCSV) {
    var reportDetailParams = _cloneDeep(report_details);
    reportDetailParams.data_details = reportDetailParams.data_details.map(data => JSON.stringify(data));
    var data = dataSources.map((source) => {
      console.log('url', `/api/v1/reports/${source.system_data ? source.name : 'external_data'}`)
      return (
        $.ajax({
          type: 'POST',
          url: `/api/v1/reports/${source.system_data ? source.name : 'external_data'}`,
          data: { report_details: reportDetailParams,
            include_yoy: report_details.includeYOY ? report_details.includeYOY : false,
            export_csv: exportCSV,
            property_id: report_details.property_id,
          },
        }).done((response) => {
          console.log('response', response)
          return response.data
        })
      );
    })
    return data;
  };

  resolveAggregateAndSetData(report_details, dataPromises) {
    // if (this.props.report_details.data_details.find(detail => detail.segment_ids)) {
    //   var reportDetailsCopy = JSON.parse(JSON.stringify(report_details))
    //   report_details.data_details = reportDetailsCopy.data_details.map((detail) => {
    //     if (detail.segment_ids && detail.segment_ids.length) {
    //       detail.data_column_name = detail.data_column_name + ' - ' + detail.segment_ids[0].name
    //     }
    //     if (detail.secondary_segment_ids && detail.secondary_segment_ids.length) {
    //       detail.data_column_name = detail.data_column_name + ' - ' + detail.secondary_segment_ids[0].name
    //     }
    //     return detail
    //   });
    // };

    var finalData = []
    Promise.all(dataPromises).then((promises) => {
      // debugger
      if (promises.length === 1) {
        this.setState({
          data: promises[0].data,
          includeYOY: report_details.includeYOY ? report_details.includeYOY : false,
        });
      } else {
        promises.forEach((promise, idx) => {
          if (idx === 0 && finalData.length === 0) {
            finalData = promise.data
          } else {
            finalData = finalData.map((dataPoint, dataPointIdx) => {
              promise.data.forEach((point, idx) => {
                report_details.data_details.forEach((detail) => {
                  if (point[detail.data_column_name] && dataPointIdx === idx || point[detail.data_column_name] === 0 && dataPointIdx === idx) {
                    dataPoint[detail.data_column_name] = point[detail.data_column_name]
                  };
                });
              });
              return dataPoint
            });
            this.setState({
              data: finalData,
              includeYOY: report_details.includeYOY ? report_details.includeYOY : false,
            });
          };
        });
      };
    });
  };


  onClickToolTip(values) {
    values ? this.setState({ toolTipDetails: values }) : null;
  };

};
